const AMPLITUDE_ACTION_EVENT_NAMES = {
    COURSE_SAVED: 'Course Saved',
    REMOVE_COURSE: 'Course Unsaved'
};
const SAVED_COURSES_TRANSLATION_KEY = 'saved-courses';
export { AMPLITUDE_ACTION_EVENT_NAMES, SAVED_COURSES_TRANSLATION_KEY };
